import { Link } from "react-router-dom";

const Topbar = ({ onToggleMenu }) => {
  return (
    <div className="col-12 flex justify-content-between align-items-center bg-white p-4 border-bottom-2 border-gold lg:p-2 lg:border-bottom-0">
      <Link to="/" className="flex align-items-center">
        <img
          src="./website/Chinmmaisystemss.png"
          alt="CS Logo"
          height="50"
          className="mr-3"
        />
      </Link>

      <div className="menu-icon lg:hidden" onClick={onToggleMenu}>
        <i className="pi pi-bars" style={{ fontSize: '2rem' }} ></i>
      </div>
    </div>
  );
};

export default Topbar;
